import { render, staticRenderFns } from "./bondmsg.vue?vue&type=template&id=099323f9&scoped=true&"
import script from "./bondmsg.vue?vue&type=script&lang=js&"
export * from "./bondmsg.vue?vue&type=script&lang=js&"
import style0 from "./bondmsg.vue?vue&type=style&index=0&id=099323f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099323f9",
  null
  
)

export default component.exports